// extracted by mini-css-extract-plugin
export default {"text":"b86WZ","textOutside":"XT0Yd","textToday":"esg90","textSelected":"eflG5"};